import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import get from 'lodash/get';

import BadgeSlash from 'Components/Carousel/FeaturedCarouselPanels/PanelComponents/BadgeSlash';
import HitsCarousel from 'Components/Carousel/FeaturedCarouselPanels/PanelComponents/HitsCarousel';
import LinkTag from 'Components/Carousel/LinkTag';
import PrimaryMessage from 'Components/Carousel/PrimaryMessage';
import useViewport from 'Hooks/useViewport';

function CategorySalePanel({
  dealsLive,
  slide,
  slideClickFunction,
  slideExternalLink,
  slideUrl,
  switchCoverImg,
}) {
  const { isAboveMd } = useViewport();

  const showMessageBlock = slide.primary_message
  || slide.primary_message_type !== 'none';

  const totalHits = get(slide, 'total_hits', 0);

  let buttonText = 'viewAll';
  let buttonTextCount = 0;
  if (slide.type === 'siteWideSale' && dealsLive > 0) {
    buttonText = 'viewAllCount';
    buttonTextCount = dealsLive;
  }
  if (slide.type !== 'siteWideSale' && totalHits > 0) {
    buttonText = 'viewAllCount';
    buttonTextCount = totalHits;
  }

  return (
    <div className="CategorySalePanel CarouselPanel">
      <div className="CarouselPanel__topContainer">
        <div className="CarouselPanel__BadgeWishlistContainer">
          <BadgeSlash type={slide.type} />
        </div>

        <h2 className="CarouselPanel__title">
          <LinkTag
            url={slideUrl}
            externalLink={slideExternalLink}
            className="faux-block-link__overlay-link"
            onClick={() => slideClickFunction()}
          >
            {slide.name}
          </LinkTag>
        </h2>

        {isAboveMd &&
          <HitsCarousel
            autoPlay
            hits={slide.hits}
            slideRows={2}
            switchCoverImg={switchCoverImg}
            type="category"
          />
        }

        {showMessageBlock &&
          <div className="CarouselPanel__messageBlock CarouselPanel__section">
            <PrimaryMessage
              customMessage={slide.primary_message}
              messageType={slide.primary_message_type}
              messageData={slide.promotional_message_data}
            />
          </div>
        }
      </div>
      <LinkTag
        className="CarouselPanel__bottomContainer faux-block-link__overlay-link"
        url={slideUrl}
        externalLink={slideExternalLink}
        onClick={() => slideClickFunction()}
      >
        <div
          className="CarouselPanel__button CarouselPanel__button--primary w-100"
        >
          {buttonText === 'viewAll' &&
            <FormattedMessage id="categorysalepanel.viewalldeals" defaultMessage="View All Deals" />
          }
          {buttonText === 'viewAllCount' &&
            <FormattedMessage id="categorysalepanel.viewdealscount" defaultMessage="View all {buttonTextCount} Deals" values={{ buttonTextCount }} />
          }

        </div>
      </LinkTag>
    </div>
  );
}

CategorySalePanel.propTypes = {
  dealsLive: PropTypes.number,
  slide: PropTypes.shape({}),
  slideClickFunction: PropTypes.func,
  slideExternalLink: PropTypes.bool,
  slideUrl: PropTypes.string,
  switchCoverImg: PropTypes.func,
};

CategorySalePanel.defaultProps = {
  dealsLive: 0,
  slide: {},
  slideClickFunction: () => {},
  slideExternalLink: false,
  slideUrl: '',
  switchCoverImg: () => {},
};

const mapStateToProps = ({
  sales: { dealsLive },
}) => ({ dealsLive });

export default connect(mapStateToProps)(CategorySalePanel);
